module.exports = __webpack_public_path__ + "media/assets/images/layout/bg_body-7509887854601a87aa643f6c2b7214a1.jpg";